import { SchemaWidgetInstance } from '../SchemaWidgetClass'
import { postalAddressJson } from './postalAddressJsonLd'

export const personJson = (data: SchemaWidgetInstance, page: any) => {
  const address = postalAddressJson(data, null)

  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    honorificPrefix: data.get('honorificPrefix') || page?.get('salutation') || null,
    givenName: data.get('givenName') || page?.get('firstName') || null,
    familyName: data.get('familyName') || page?.get('lastName') || null,
    name:
      data.get('name') ||
      [page?.get('firstName'), page?.get('lastName')].filter(Boolean).join(' ') ||
      null,
    description: data.get('description') || page?.get('description') || null,
    jobTitle: data.get('jobTitle') || page?.get('belonging') || null,
    email: data.get('email') || page?.get('email') || null,
    telephone:
      data.get('telephone') || page?.get('altPhoneNumber') || page?.get('phoneNumber') || null,
    worksFor: {
      '@type': 'CollegeOrUniversity',
      name: 'Hochschule Heilbronn',
      url: 'https://www.hs-heilbronn.de',
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        ...address,
        streetAddress: address.streetAddress || page?.get('street') || null,
        addressLocality: address.addressLocality || page?.get('officeLocation') || null,
        postalCode: address.postalCode || page?.get('postalCode') || null,
      },
    },
  }
}
